import { FC } from "react";
import { useTranslation } from "react-i18next";

import { MuiButton } from "@ryde/controls";

import { useDashboardViews } from "../../hooks/use-dashboard-views";
import { ViewDropdownOptionStyled } from "./dashboard-view.styled";

export const DashboardResetDefaultsButton: FC = () => {
  const { t } = useTranslation();
  const { resetToDefault } = useDashboardViews();

  return (
    <ViewDropdownOptionStyled>
      <MuiButton
        muiVariant="text"
        className="ViewDropdownOption-ResetButton"
        onClick={resetToDefault}
      >
        {t("view.resetDefaults")}
      </MuiButton>
    </ViewDropdownOptionStyled>
  );
};
